export default [
  {
    key: "isPrivate",
    rules: {
      isRequired: true,
    }
  },
  {
    key: "productStatus",
    rules: {
      isRequired: true,
    }
  },
  {
    key: "productType",
    rules: {
      isRequired: true,
    }
  },
  {
    key: "elsaContractTypes",
    rules: {
      isRequired: true,
    }
  }
]
